import { styled } from "@mui/material/styles";

const StyledLowInStock = styled("div")(
  ({ theme }) => `
width: 57%;
   @media (max-width: 1200px){
   width: 100%
   }

  .main-container {
  height:calc(100% - 16px);
   width: 100%;
   background-color: ${theme.palette.customColor.white};
   margin-top: 16px;
 

   .main-title {
   font-family: 'Lexend', sans-serif;
   font-weight: 500;
   font-size: 20px;
   line-height: 24px;
   padding: 20px;
   color: ${theme.palette.primary.main};
   }
   .cards-container {
   display: flex;
   gap: 12px;
     flex-wrap: nowrap;
   overflow: auto;
   white-space: nowrap;
  -webkit-overflow-scrolling: touch; 
   scrollbar-width: none; 
   padding-left: 20px !important;
  max-height: 444px;

   }


   .content-box-1{
   padding-left: 0px !important;
    padding-right: 0px !important;
    padding-top: 6px !important;
   }
    
   .cards-box {
   box-shadow: none;
   border-radius: 0;
      flex: 0 0 auto; 
   width:  206px; 
 
   }
   .cards-img {
   height: 273px;  
   }
   .title {
   font-family: 'Lexend', sans-serif;
   font-weight: 500;
   font-size: 10px;
   line-height: 12.5px;
   color: ${theme.palette.tertiary.main};
   margin-bottom: 6px;
   padding-top: 6px;
   }

   .detail {
   font-family: 'Lexend', sans-serif;
   font-weight: 400;
   font-size: 14px;
   line-height: 17.5px;
   color: ${theme.palette.primary.main};
   margin-bottom: 6px;
   }   
   .product {
   font-family: 'Lexend', sans-serif;
   font-weight: 400;
   font-size: 12px;
   line-height: 15px;
   color:  ${theme.palette.customColor.secondarySecond};
   margin-bottom: 16px;
      white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
   }
   .MuiCardContent-root {
    padding: 20px;
    padding-bottom: 20px;
}

.value {
font-family: Lexend;
font-weight: 400;
font-size: 12.16px;
line-height: 100%;

}

.icon-no-data{
font-size: 30px;
}

.loader-container { 
margin-left: 3%;
 width: 94%;
 height: 82%;
 min-height: 400px;
 margin-bottom: 20px;
   position: relative;}
  
`
);

export default StyledLowInStock;
